// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Config extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(50) key */
  groupName!: string;
  /** String(50) key */
  fieldName!: string;
  /** String(100) */
  fieldDescription!: string;
  /** String(10) */
  fieldType!: string;
  /** Binary */
  rowVersion!: any;
  /** Boolean */
  shouldDisplay!: boolean;
  /** String */
  value?: string;
}

